import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HeaderService } from '../header.service';
import RoutesserviceService from '../routesservice.service';
import { ThemeService } from 'src/app/theme.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    private httpClient: HttpClient,
    private Customeroutes: RoutesserviceService,
    private HeaderService: HeaderService,
    private themeService: ThemeService,
    private router: Router,

  ) { }

  //    async logout(){
  //     // let check = false;
  //        return this.httpClient
  //       .post(this.Customeroutes.getLogout(), '', {
  //         headers: this.HeaderService.getHeaderWithToken(localStorage.getItem('token')),
  //       })
  //       .pipe()
  //       .toPromise()
  //       .then((data: any) => {
  //          if (data.success == true) {
  //            //if login is true the store it into local storage
  //            localStorage.removeItem('token');

  //            let token =  localStorage.getItem('token')
  //            this.themeService.clearThemeId();
  //            localStorage.clear();
  //            return data;
  //          }
  //       });
  // }
  async logout() {
    return this.httpClient
      .post(
        this.Customeroutes.getLogout(),
        '',
        {
          headers: this.HeaderService.getHeaderWithToken(localStorage.getItem('token')),
        }
      )
      .toPromise()
      .then((data: any) => {
        if (data?.success == true) {
          this.clearSession();
        }
        return data;
      })
      .catch((err) => {
        // If token expired/invalid (401), still clear session
        if (err.status == 401) {
          this.clearSession();
        }
        else {
          this.clearSession();
        }
        return err;
      });
  }

  private clearSession() {
    this.themeService.clearThemeId();
    localStorage.clear();
    this.router.navigate(['/']); // optional: force redirect
  }

}
